/**
 * Padrão de ações da Sede Corporativa e da Empresa Cliente.
 *
 * Dentro de cards, toda ação tem a mesma forma — botão compacto com borda (32px, ícone +
 * texto) — e só a cor muda com a importância:
 *  - `CARD_ACTION`: ação comum (Testar conexão, Reconectar, Editar, Reajustar...);
 *  - `CARD_ACTION_DANGER`: ação de risco (Desconectar, Cancelar assinatura, Descartar...);
 *  - `Button variant="primary" size="sm"` + `CARD_PRIMARY`: no máximo um por card, só
 *    quando há algo pendente para o usuário fazer ("Conectar com Google").
 * Botão sem borda parecia texto (o usuário não percebia que era clicável), e misturar
 * borda grossa (`outline`) com botões de texto deixava a linha sem padrão.
 * Rodapé de modal: `Button size="sm"`; ação de risco no rodapé usa `CARD_ACTION_DANGER`
 * + `FOOTER_ACTION` (mesma altura dos botões ao lado).
 */
const BASE =
  "inline-flex items-center justify-center gap-1.5 h-8 px-3 rounded-lg border bg-white text-xs font-semibold whitespace-nowrap transition-colors focus-visible:outline-hidden focus-visible:ring-2 disabled:opacity-50 disabled:cursor-not-allowed";

/** Ação comum: borda cinza, roxo no hover. */
export const CARD_ACTION = `${BASE} border-gray-200 text-gray-700 hover:border-purple-300 hover:bg-purple-50 hover:text-purple-700 focus-visible:ring-purple-400`;

/** Ação de risco (desconectar, descartar, cancelar assinatura, desativar). */
export const CARD_ACTION_DANGER = `${BASE} border-rose-200 text-rose-600 hover:border-rose-300 hover:bg-rose-50 focus-visible:ring-rose-300`;

/** No rodapé do modal: mesma altura e fonte do `Button size="sm"` ao lado. */
export const FOOTER_ACTION = "sm:h-9 sm:text-sm";

/**
 * Botão preenchido compacto dentro de card (mesma altura dos demais).
 * `!`: o projeto não usa tailwind-merge, então sem ele as classes de tamanho do
 * `Button` colidiriam (§8 do design system).
 */
export const CARD_PRIMARY = "!min-h-8 !h-8 !px-3 !text-xs !shadow-none";
